import axios from 'axios'

const config = {
    server: null,
    timeout: 15000,
    retry_interval: 60000,
}
const server = config.server || 'http://127.0.0.1:4001'
const timeout = config.timeout || 15000
const retryInterval = config.retry_interval || 60000

let reconnectProcess = null
const httpClient = axios.create({
    baseURL: `${server}/api`,
    timeout,
})

// httpClient.interceptors.response.use(response => {
//     setConnectionStatus(response.data.message !== 'requested_boards_disconnected')
//     return response
// }, error => {
//     if (error.response) {
//         setConnectionStatus(error.response.data.message !== 'requested_boards_disconnected')
//     } else {
//         // Manual generate response for listener handle
//         error.response = {
//             data: {
//                 message: 'PCB server no response',
//             },
//         }

//         setConnectionStatus(false)
//     }

//     return Promise.reject(error)
// })

const forceRunMotor = (motorIndex) => {
    return httpClient.post('/boards/run_motor/' + motorIndex, null, {
        params: {
            force: true,
        },
    }).then(({ data }) => {
        return Promise.resolve(data.data)
    }).catch(error => {
        return Promise.reject(error.response)
    })
}

export { forceRunMotor }